/**
 * PDP Micro-interactions
 * - ATC celebration: emoji burst + success state
 * Dawn PubSub (subscribe/PUB_SUB_EVENTS) global olarak kullanılır.
 */

(function () {
  'use strict';

  const EMOJIS = ['❤️', '✨', '🌸', '⭐', '💫', '🎀', '🪡'];

  function triggerCelebration(btn) {
    if (!btn || btn.dataset.celebrating) return;
    btn.dataset.celebrating = '1';

    btn.classList.add('is-success');
    const label = btn.querySelector('.aycan-atc__label') || btn.querySelector('span');
    const prevText = label ? label.textContent : btn.textContent;

    if (label) label.textContent = '✓ Added to Cart!';
    else btn.textContent = '✓ Added to Cart!';

    setTimeout(() => {
      btn.classList.remove('is-success');
      if (label && prevText) label.textContent = prevText;
      else if (prevText) btn.textContent = prevText;
      delete btn.dataset.celebrating;
    }, 1800);

    const rect = btn.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;

    for (let i = 0; i < 8; i++) {
      const el = document.createElement('span');
      el.className = 'pdp-emoji-burst';
      el.textContent = EMOJIS[Math.floor(Math.random() * EMOJIS.length)];

      const angle = (i / 8) * Math.PI * 2 - Math.PI / 2;
      const dist = 55 + Math.random() * 50;
      el.style.cssText = `left:${cx}px;top:${cy}px;` +
        `--dx:${(Math.cos(angle) * dist).toFixed(1)}px;` +
        `--dy:${(Math.sin(angle) * dist - 25).toFixed(1)}px;`;

      document.body.appendChild(el);
      setTimeout(() => el.remove(), 900);
    }
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (!data) return;
      const sources = ['aycan-design-picker', 'aycan-coaster-picker', 'product-form'];
      if (!sources.includes(data.source)) return;

      const btn =
        document.querySelector('[data-dock-cta]') ||
        document.querySelector(
          '.aycan-design-picker__atc, .aycan-coaster__atc, .aycan-buybox .product-form__submit'
        );
      triggerCelebration(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
